import * as React from 'react';
import styled from '@emotion/styled';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTheme } from '@mui/material/styles';

const StyledDivResponse = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
`;

const StyledText = styled.h3`
  margin: 0 0 3rem 0;
`;
const StyledTextFirstLine = styled.h3`
  margin: 0 0 1rem 0;
`;
const StyledDivIcon = styled.h3`
  margin-bottom: 2rem;
`;

interface SuggestEditSuccessResponseProps {
  children: React.ReactNode;
}

const SuggestEditSuccessResponse = ({ children }: SuggestEditSuccessResponseProps) => {
  const {
    palette: {
      success: { main: successColor },
    },
  } = useTheme();

  return (
    <StyledDivResponse>
      <StyledDivIcon>
        <CheckCircleIcon sx={{ color: `${successColor}`, fontSize: '3rem' }} />
      </StyledDivIcon>
      <StyledTextFirstLine>Thank you</StyledTextFirstLine>
      <StyledText>Your suggested edit has been submitted</StyledText>
      {children}
    </StyledDivResponse>
  );
};

export default SuggestEditSuccessResponse;
